import { useTheme } from '@mui/material';

export const PrivacyPolicyContent = () => {
  const theme = useTheme();
  return (
    <div>
      <p>
        This page is to illustrate visitors regarding our policies with collection, using, and
        disclosure of Personal data. When a user decided to use our Service this policies would be
        automaticaly applied by the user. If you choose our service, then you agree to collection
        and use of information in relation to this policy. We use the personal information providing
        and improving the service. We don`t use or share any information with other people or
        companies exceptet as described in this PRIVACY POLICY.
      </p>
      <p>
        The terms used in this Privacy Policy have the same meanings as in our Terms and Conditions,
        which is accessible at XCIPTV Player Ultra Stream unless otherwise defined in this Privacy Policy.
      </p>
      <p>
        <br />
      </p>
      <h3>Why we are collection information and use?</h3>
      <p>
        We are collecting information about the user for a better experience, while using our
        service. For this maybe we need certain personally information. The Information, which are
        requested from us will not be retrained on your device and will not collected by us in any
        way.
      </p>
      <p>
        The app doesnt use for now third party services that may collect information used to
        identify you. It can be changed without giving noticed and if you use the service you agree
        with that. Because of this please visit our Privacy and Policy many times.
      </p>
      <p>
        <br />
      </p>
      <h3>Log Data</h3>
      <p>
        We want to inform you that whenever you use our service, in case of an error or version
        incompatibility oft he app and the device, that we collect your date for taking information
        (through third party products) on you device called Log Data. Those Log data may include
        information such as your device operating system version, internet protocol &quot;IP&quot;
        address and the device name. Date and Time is too visible in the log data.
      </p>
      <p>
        <br />
      </p>
      <h3>Cookies</h3>
      <p>
        In this section we would give you some information about the cookies. Cookies are small
        amount of data which will be saved on you devices internal memory. This ware sent to you
        browser from the websites that you visit. We dont use directly cookies but the app may use
        third party code and libraries that use &quot;cookies&quot; for improve their services.
        While using a browser you can accept this our refuse these cookies. When you first time
        visit a website, you would be asked bye the devices if you want to save cockies. In this
        case you can agree or disagree.
      </p>
      <p>
        <br />
      </p>
      <h3>Service Providers</h3>
      <p>
        For updating and developing the app we need sometimes third-party companies and individual
        due to the following reasons:
      </p>
      <p>To make the use of the app easier.</p>
      <p>Companies, which helping use while programming and updating</p>
      <p>
        We have to inform users of our service, that these companies or third parties have access to
        your personal information. Only when they get a job from ous they have acces to you data
        too. Which means that the third-parties only use your data for developing phase. However,
        they are obligated not to disclose or use the information for any other purpose.
      </p>
      <p>
        <br />
      </p>
      <h3>E-mail contact</h3>
      <p>
        If you contact us via the provided e-mail address, the data you provide will be used to
        process your request. The specification of the data is necessary for processing and
        answering your inquiry - without their provision we can not answer your inquiry or at best
        only to a limited extent. Legal basis for this processing is in the presence of a consent
        Art. 7 para. 1 lit. a GDPR. The legal basis for the processing of the data transmitted in
        the course of sending an e-mail is Article 7 (1) lit. f DSGVO.
      </p>
      <p>
        The data will be deleted as soon as it is no longer necessary to achieve the purpose of its
        collection. For the personal data sent by e-mail, this is the case when the respective
        conversation with the user has ended. The conversation ends when it can be inferred from the
        circumstances that the matter in question has been finally clarified.
      </p>
      <p>
        <br />
      </p>
      <h3>Security oft he data and information</h3>
      <p>
        In this case we have to speak about the security of collected data and information. We don`t
        publish any kind of information about you. But sure internet and same protocols are not
        secure for 100% and because of this we are working everytime for security and realibility,
        but we can not gurantee its absolute security.
      </p>
      <p>
        <br />
      </p>
      <h3>Links to Other Sites</h3>
      <p>
        On our site you can find other links from other sites. If you click on them, you will be
        directed to that site. Note that these externel sites are not operated by us. Because of
        this please review the Privacy Policy of these websites. We don`t have any control over
        other sites and because this you should review the Privacy and Policy of these sites for
        prodecting you from miss understanding. Like we say before, we are not responsible for other
        sites.
      </p>
      <p>
        <br />
      </p>
      <h3>Childrens Privacy</h3>
      <p>
        Our Service do not address anyone under the age of 15, because of this we do not knowingly
        collect personaly identifiable information from children under 15. When we see that there is
        data from a child under 15, we will remove it immediately from our service. And if you are
        parent of a child, which send us their data please contact us to take actions.
      </p>
      <p>Updating this Privacy Policy</p>
      <p>
        We will update our Privacy Policy from time to time. Because of this, thus who use our
        service should visit the page periodically for sean any changes. The updated Privacy Policy
        is effective after we are publishing them on this site.
      </p>
      <p>
        <br />
      </p>
      <h3>Contact Us</h3>
      <p>
        For any question or suggestions about our Privacy Policy, do not hesitate to contact us
        at&nbsp;
        <a
          style={{ color: theme.palette.text.primary, fontWeight: 'bold' }}
          href="mailto:streamingtechllc@gmail.com"
        >
          streamingtechllc@gmail.com
        </a>
      </p>
    </div>
  );
};
